import React, { useCallback, useEffect, useState } from 'react';
import {
  AppButton,
  Box,
  Preloader,
  SuccessModal,
  Text,
  WarningIcon,
  WarnModal,
} from '@common-fe/common-fe';

import { Modal } from '@/components';

import { ITaxModalPayload } from '../TaxForms.types';

import { useTaxFormSendMEssageQueueQuery } from './queries';

interface Props {
  currentTaxForm: ITaxModalPayload | null;
  onSetCurrentTaxForm: (value: ITaxModalPayload | null) => void;
}
const TaxFormsMessageQueueModalContainer: React.FC<Props> = ({ currentTaxForm, onSetCurrentTaxForm }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (currentTaxForm !== null) {
      setVisible(true);
    }
  }, [currentTaxForm]);
  const [successVisible, setSuccessVisible] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const { isLoading, submit } = useTaxFormSendMEssageQueueQuery();
  const handleClose = () => {
    onSetCurrentTaxForm(null);
    setVisible(false);
  };

  const handleSubmit = useCallback(async () => {
    if (currentTaxForm) {
      try {
        setVisible(true);
        await submit(currentTaxForm);
        setSuccessVisible(true);
        setVisible(false);
      } catch {
        setVisible(false);
        setErrorVisible(true);
      }
    }
  }, [currentTaxForm, submit]);
  if (!currentTaxForm) {
    return null;
  }
  return (
    <>
      <WarnModal
        testId="error-modal"
        visible={errorVisible}
        onSetVisible={setErrorVisible}
        header="The server encountered an error processing the request"
        buttonText="Close"
        onSubmit={handleSubmit}
        submitButtonText="Try again"
      />
      <SuccessModal
        testId="success-modal"
        visible={successVisible}
        onSetVisible={setSuccessVisible}
        header="Tax form is on its way"
        buttonText="Got It!"
      />
      <Modal testId="message-queue-modal" visible={visible} onSetVisible={handleClose}>
        <Box direction="column" margin={{ vertical: 'spacing24' }}>
          <Box direction="column" align="center" justify="center">
            <WarningIcon size="48px" color="warning" />
            <Text
              data-testid="message-queue-modal_title"
              size="2xl"
              weight={700}
              margin={{ vertical: 'spacing12' }}
            >
              Mail tax form?
            </Text>
          </Box>

          <Box margin={{ horizontal: 'spacing24' }}>
            <Text textAlign="center" data-testid="message-queue-modal_description">
              Once confirmed, this tax form will be queued for physical delivery. This process cannot be
              canceled and may take up to 14 days to reach the employee.
            </Text>
          </Box>
          <Box direction="row" align="center" justify="center" gap="spacing12" margin={{ top: 'spacing24' }}>
            <AppButton
              testId="message-queue-modal_cancel"
              buttonType="secondary"
              width="180px"
              onClick={handleClose}
            >
              Cancel
            </AppButton>

            <AppButton
              testId="message-queue-modal_confirm"
              buttonType="primary"
              width="180px"
              onClick={handleSubmit}
            >
              {isLoading ? <Preloader /> : 'Confirm'}
            </AppButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
export default TaxFormsMessageQueueModalContainer;
